import React, {ChangeEvent, Component, createRef, RefObject} from 'react';
import {Accordion, Modal} from 'react-bootstrap';
import {TFunction, withTranslation} from "react-i18next";
import {ReactComponent as IconDownloadSVG} from "itd-common/assets/icons/download.svg";
import {ReactComponent as IconPrintSVG} from "itd-common/assets/icons/icon-print-white.svg";
import {ReactComponent as IconSettingSVG} from "itd-common/assets/icons/settings.svg";
import {ReactComponent as HeartOrangeSVG} from "itd-common/assets/icons/heart-orange.svg";
import {ReactComponent as IconTrashSVG} from "itd-common/assets/icons/trash.svg";
import {ReactComponent as IconCloseSVG} from "itd-common/assets/icons/close.svg";
import {FiscalSettlementService} from '../../services/FiscalSettlementService';
import {UtilService} from '../../services/UtilService';
import ErrorsView from '../ErrorsView';
import Card from '../containers/card';
import FormFilter from '../containers/form-filter';
import Page from '../containers/page';
import Button from '../controls/buttons/button';
import SelectField from '../controls/fields/selectField';
import TextField from '../controls/fields/textField';
import NavigationTabLinksForSettlements from './NavigationTabLinksForSettlements';
import {
    actionColumnDefinition,
    ColumnDefinition,
    currencyColumnDefinition,
    currencyTypeColumnDefinition,
    dateColumnDefinition,
    numericColumnDefinition,
    textColumnDefinition
} from '../table/ColumnDefinition';
import CustomTable, {TableModeEnum} from '../table/CustomTable';
import CheckBoxField from '../controls/fields/checkBoxField';
import {
    ReactComponent as IconDownloadWhiteSVG
} from "itd-common/assets/icons/icon-download-white.svg";
import {
    IDownloadMonthlyESettlement,
    IMonthlySettlementsRequest,
    NewFavoritemonthlyRequest
} from '../../requests/ISettlementsRequest';
import {
    IFavoriteMonthlySettlementResponse,
    IMonthlyFavoriteSettlement,
    IMonthlySettlement,
    IMonthlySettlements
} from '../../models/ISettlementData';
import {AxiosResponse} from 'axios';
import {Option} from '../../models/Option';
import {toast} from 'react-toastify';
import CustomReCAPTCHA from '../CustomCaptcha';
import {WebCache} from "../../services/WebCache";
import './Settlement.scss'
import {OptionMapperHelper} from "../../helpers/OptionMapperHelper";
import i18next, {t} from "i18next";
import ReactToPrint from "react-to-print";
import TypeaheadField from '../controls/fields/typeaheadField';
import {SettlementService} from "../../services/SettlementService";
import FilterFiscalDocumentAndCommerce, {MultiSelectRef} from "../FilterFiscalDocumentAndCommerce";
import {IMessageContext} from "../MessagesContext";
import {withMessages} from "../contexts/MessagesContext";
import MultiSelectField from '../controls/fields/multiSelectField';
import Pagination from '../Pagination';

interface IProps {
    t: TFunction
    messages: IMessageContext
}
interface IFilters {
    period: string,
    //accountNumber: number,
    fiscalDocument: string[],
    merchantNumber: string[],
    //amount: number,
    //type: string,
    currency: string,
    brands: string[]
}
interface IState {
    mainPage: number,
    pageRequest: IMonthlySettlementsRequest,
    monthlySettlements: IMonthlySettlements,
    errors: string[],
    columnDefinitions: Array<ColumnDefinition>,
    favSelected: string,
    favoriteName: string,
    favorites: IMonthlyFavoriteSettlement[],
    filters: IFilters,
    periodOptions: Array<HTMLOptionElement>,
    brandOptions: Option[],
    currencyOptions: Array<HTMLOptionElement>,
    isModalOpen: boolean,
    isFavoriteModalOpen: boolean,
    isMakingNewFavorite: boolean,
    hiddenColumnsMap: Map<string, boolean>,
    isCaptchaVerified:boolean,
    pages: number[],
    activePage:number
}

const pageSize=20
const pageQuantity=3
const defaultPages = [1, 2, 3]
const T_PREFIX: string = 'pages.settlementsByMonth.';
let lastFiscalDocument:string=""
class SettlementsByMonth extends Component<IProps, IState> {
    private componentRef:RefObject<any> = React.createRef();
    private multiSelectRef = createRef<MultiSelectRef>();
    private messages: IMessageContext = this.props.messages;
    private divColumnSize: string = UtilService.isMobilePlatform() ? "col-md-6" : "col-md-6 col-lg-4";

    constructor(props: IProps) {
        super(props);

        const periodOptions: Array<HTMLOptionElement> = this.props.t(`${T_PREFIX}months`, { 
            returnObjects: true 
        });
        const brandOptions= new OptionMapperHelper(t).translateOptionValues(WebCache.getAllUnfilteredProducts(true));
        const brandFilter: Option = brandOptions[0];
        const currencyOptions: Array<HTMLOptionElement> = UtilService.getCurrencyOptions();
        const currencyFilter: string = currencyOptions[0].value;
        const currentDate = new Date(); // current date
        currentDate.setDate(1);
        currentDate.setMonth(currentDate.getMonth() - 1);
        const defaultPeriod=currentDate.getFullYear()+"-"+(currentDate.getMonth()+1)
        const typeOptions: Array<HTMLOptionElement> = this.props.t(`${T_PREFIX}tipos`, {
            returnObjects: true 
        });
        const type: string = typeOptions[0].value;
        
        let columnDefinitions = [
            dateColumnDefinition({ key: 'period', label: `${T_PREFIX}columns.period`, header: true, mapValue: (settlement: IMonthlySettlement) => {
                if (!settlement.period) {
                    return '';
                }
                const period: string = settlement.period.toString();
                const year: string = period.substring(0, 4);
                const month: string = period.substring(4, 6);
                return `${month}/${year}`;
            } }),
            textColumnDefinition({ key: 'productDesc', label: `${T_PREFIX}columns.productDesc`, header: true, mapValue: (settlement: IMonthlySettlement) => {
                const product= settlement.productDesc;
                if (product == "Visa Débito"){
                    return <div>
                                <img src={UtilService.getImageTag(product)} alt={`${product}`}/>
                                <p >Débito</p>
                            </div>  ;    
                }else if (product == "Visa Crédito"){
                    return <div>
                                <img src={UtilService.getImageTag(product)} alt={`${product}`}/>
                                <p>Crédito</p>
                            </div>  ;                  
                } else if (product == "Adelanto Liquidación Visa"){
                    return <div>
                        <img src={UtilService.getImageTag(product)} alt={`${product}`}/>
                        <p >Adelanto Liq.</p>
                    </div>  ;
                }else if (product == "Adelanto Liquidación Master"){
                    return <div>
                        <img src={UtilService.getImageTag(product)} alt={`${product}`}/>
                        <p >Adelanto Liq.</p>
                    </div>  ;
                } else {
                return <img src={product==null?"":UtilService.getImageTag(product.toUpperCase())} alt={`${product}`} ></img>;
            }
            }}),
            numericColumnDefinition({ key: 'merchantNumber', label: `${T_PREFIX}columns.merchantNumber`, header: true }),
            currencyTypeColumnDefinition({ key: 'currencyCode', label: `${T_PREFIX}columns.currencyCode`, header: true }),
            currencyColumnDefinition({ key: 'grossAmount', label: `${T_PREFIX}columns.grossAmount`, header: true, columnDefinitionKey:'currencyCode' }),
            currencyColumnDefinition({ key: 'netAmount', label: `${T_PREFIX}columns.netAmount`, header: true, columnDefinitionKey:'currencyCode' }),
            actionColumnDefinition({ key: 'download', label: `${T_PREFIX}columns.download`, header: true, action: { function: (rowObject: IMonthlySettlement) => {
                //this.messages.showToastDownloadMessage()
                this.getDowloadESettlement(rowObject.id, rowObject.merchantNumber, rowObject.productDesc, rowObject.period);
            }, icon: <IconDownloadSVG className="icon-download"></IconDownloadSVG> } }),
        ];

        const hiddenColumnsMap: Map<string, boolean> = new Map();
        columnDefinitions.forEach(columnDefinition => hiddenColumnsMap.set(columnDefinition.key, columnDefinition.hidden || false));

        this.state = {
            mainPage: 0,
            pages: defaultPages,
            activePage: 1,
            pageRequest: {
                AccountNumber: '',
                MerchantDocuments:[],
                From: '',
                To: '',
                Type: '',
                Amount:'',
                Currency: '',
                Skip: 0,
                Take: 0,
                MerchantNumbers:[],
                Brands: [],
                AddDetail:false
            },
            monthlySettlements: {
                monthlySettlements: [] as IMonthlySettlement[],
                totalNetAmount: '',
                totalNetAmountUS: '',
                recordsNumber: ''
            } as IMonthlySettlements,
            errors: [],
            columnDefinitions,
            favorites: [],
            favSelected: '',
            favoriteName: '',
            filters: {
                period:defaultPeriod,
                fiscalDocument: [""],
                merchantNumber: [""],
                currency: currencyFilter,
                brands: [""],
            },
            periodOptions,
            brandOptions,
            currencyOptions,
            isModalOpen: false,
            isFavoriteModalOpen: false,
            isMakingNewFavorite: false,
            hiddenColumnsMap,
            isCaptchaVerified:sessionStorage.getItem('captchaVerified')=="true"
        };    
        this.getFavorites();
    }

/*     componentDidUpdate(prevProps: any, prevState: IState) {
        if (prevState.filters.brands !== this.state.filters.brands) {
            const isAllSelected = this.state.filters.brands.some(option => option.value === "");
            const isAllPreviouslySelected = prevState.filters.brands.length == 1 &&
            prevState.filters.brands.some(option => option.value === "");          
    
            if (isAllSelected && this.state.filters.brands.length > 1) {
                let filteredBrands: Option[];
                if(isAllPreviouslySelected){
                    //caso que agrego una tarjeta cuando Todas las tarjetas estaban seleccionadas
                    filteredBrands = this.state.filters.brands.filter(option => option.value != "");
                }else {
                    //caso que ya habia seleccion y agrego la opcion de Todas las tarjetas
                    filteredBrands = this.state.filters.brands.filter(option => option.value === "");
                }                                
                this.setState({
                    filters: {
                        ...this.state.filters,
                        brands: filteredBrands
                    }
                });               
            }            
        }
    } */

    getCustomMonths = (): Array<Option>=>{
        let date = new Date(); // current date
        date.setDate(1);
        date.setMonth(date.getMonth() - 1);
        let monthValues: Array<Option> = [];

        for(var i = 0; i < 12; i++){
            let month: number = date.getMonth();           
            let text = this.state.periodOptions[month].label + "-" + date.getFullYear();
            let period = date.getFullYear() + "-" + this.state.periodOptions[month].value;
            let option: Option = {
            value: period,
            label: text
            };
            
            monthValues.push(option);
            date.setMonth(date.getMonth() -1);
        }

        return monthValues;
    }

    getValueToCsvExport=(x:ColumnDefinition,y:IMonthlySettlement ):string => {
        // @ts-ignore
        if(x.key=="currencyCode")
            return t("currency-"+y[x.key]);
        if(x.key=="discountAmount")
            return y.discountAmount.toFixed(2);
        if(x.key=="netAmount")
            return y.netAmount.toFixed(2);
        if(x.key=="grossAmount")
            return y.grossAmount.toFixed(2);
        // @ts-ignore
        return  y[x.key];
    }

    downloadGrid = () => {
        this.messages.showDownloadMessage();
        SettlementService.generateMonthlySettlementExcel(this.getRequest(true)).then((response: AxiosResponse<Blob>) => {
        }).catch(error => {
            this.setState({...this.state,errors: error.response.data});
            console.log('error: ', error);
        });
       /*
        let fileName="Liquidación mensual.csv";
        UserService.getCsvOnline(this.state.columnDefinitions.filter(x=>x.action==null).map(x=>i18next.t(x.label+"")).join(";")+"\r\n"+

            this.state.monthlySettlements.monthlySettlements.map(y=>this.state.columnDefinitions.map(x=>  this.getValueToCsvExport(x,y) ).join(";")).join("\r\n"), fileName).then((response: AxiosResponse<any>) => {

            const url = URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            link.click();
        }).catch(error => {
            console.log('error:', error);
        });*/
    }

    getDownloadMonthlyESettlementRequest = (fileName: string, merchantNumber: number, productDesc: string, period: number): IDownloadMonthlyESettlement => {
        const result: IDownloadMonthlyESettlement = {
            FileName: fileName,
            MerchantNumber: merchantNumber,
            ProductDesc: productDesc,
            Period: period
        };
        return result;
    }
    handleClickFavoriteModal = () => {
        this.setState({ ...this.state, isFavoriteModalOpen: !this.state.isFavoriteModalOpen });
    }
    addNewFavorite() {
        if(this.state.favorites.findIndex((item)=> item.name.toLocaleLowerCase() === this.state.favoriteName.toLocaleLowerCase()) >= 0){
            toast.error(t(`${T_PREFIX}favoriteRepeatedMessage`).toString());
            this.setState({...this.state,
                favoriteName: ""
            });
        }else{
            let request: NewFavoritemonthlyRequest= {
                name: this.state.favoriteName,
                period: this.state.filters.period.toString(),
                //rut:this.state.filters.fiscalDocument ? this.state.filters.fiscalDocument: "" ,
                //codComercio:this.state.filters.merchantDocument ? this.state.filters.merchantDocument : "",
                //brand:this.state.filters.brand? this.state.filters.brand: "",
                currency:this.state.filters.currency? this.state.filters.currency : ""
            }
            FiscalSettlementService.addMonthlyFavoriteSettlement(request).then((response: IFavoriteMonthlySettlementResponse) => {
                if(response?.success){
                    this.setState({...this.state, 
                        favorites: response?.data,
                        favoriteName: ""
                    });
                    toast.success(t(`${T_PREFIX}${response.message}`).toString());
                }
            }).catch(error => {
                console.log('error:', error);
            });
        }
    }
    deleteFavorite(name:string){
        FiscalSettlementService.deleteMonthlyFavoriteSettlement(name).then((response: IFavoriteMonthlySettlementResponse) => {
            if(response?.success){
                if(response.message==="favoriteRepeatedMessage"){
                    toast.error(t(`${T_PREFIX}${response.message}`).toString());
                }else{
                    toast.success(t(`${T_PREFIX}${response.message}`).toString());
                    this.setState({...this.state, favorites: response?.data});
                }
            }
        }).catch((error: any) => {
            console.log('error:', error);
        });
    }
    applyFavorite(value: IMonthlyFavoriteSettlement){
        this.setState({...this.state, 
            filters: {
                ...this.state.filters,
                period: value.period,
                //brand: value.brand,
                currency: value.currency,
                //merchantDocument: value.codComercio,
                //fiscalDocument: value.rut
            },
            isFavoriteModalOpen: !this.state.isFavoriteModalOpen
        });
        
    }
    getFavorites(){
        FiscalSettlementService.getMonthlySettlementFavorites().then((response: IMonthlyFavoriteSettlement[]) => {
            if(response)
                this.setState({...this.state, favorites: response});
        }).catch(error => {
            console.log('error:', error);
        });
    }

    handleCaptchaVerification = (verified: boolean) => {
        this.setState({ isCaptchaVerified: verified });
    };

    handleClickProofOfWithholdings = (event: ChangeEvent<HTMLInputElement>) => {
        if (this.state.isCaptchaVerified) {
            const selectYear: number = Number(this.state.filters.period
                .toString()
                .substring(0, 4));
            const selectMonth: number = Number(this.state.filters.period
                .toString()
                .substring(5));
            //this.messages.showToastDownloadMessage();
            FiscalSettlementService.downloadProofOfWithholdings({FiscalDocument:this.state.filters.fiscalDocument.join(','),Year:selectYear,Month:selectMonth})
                .then((response: AxiosResponse<Blob>) => {
                })
                .catch((error) => {
                    this.setState({  errors: ["Error obteniendo datos del servidor"] });
                    console.log('error:', error);
                });
        } else {
            toast.error("Por favor, verifica el CAPTCHA antes de descargar el archivo");
        }
    }

    getDowloadESettlement = (fileName: string, merchantNumber: number, productDesc: string, period: number) => {
        if (this.state.isCaptchaVerified) {
            this.messages.showDownloadMessage();
            FiscalSettlementService.getDowloadMonthlyESettlement(this.getDownloadMonthlyESettlementRequest(fileName, merchantNumber, productDesc, period))
                .then((response: AxiosResponse<Blob>) => {
                })
                .catch((error: any) => {
                    this.setState({  errors: ["Error obteniendo datos del servidor"], });
                    console.log('error:', error);
                });
    } else {
            toast.error("Por favor, verifica el CAPTCHA antes de descargar el archivo");
        }
    };

    getRequest = (all: boolean): IMonthlySettlementsRequest => {
        //const currentYear: number = new Date().getFullYear();
        //const currentYear: number = 2023;
        const selectYear: number = Number(this.state.filters.period
                                        .toString()
                                        .substring(0, 4));
        const selectMonth: number = Number(this.state.filters.period
                                            .toString()
                                            .substring(5));
        const firstDayOfTheMonth: Date = new Date(selectYear, selectMonth - 1, 1);
        const lastDayOfTheMonth: Date = new Date(selectYear, selectMonth, 0);

        const tranWebModel: IMonthlySettlementsRequest = {
            AccountNumber: "", //this.state.filters.accountNumber.toString(),
            Brands: this.state.filters.brands.includes("all") ? []: this.state.filters.brands.filter(x => x.length > 0).map(x => x.startsWith("productCode-") ? x.replace("productCode-", "") : x),
            MerchantDocuments: this.state.filters.fiscalDocument.includes("all") ? [] : this.state.filters.fiscalDocument.filter(x=>x.length>0),
            MerchantNumbers: this.state.filters.merchantNumber.includes("all")? [] : this.state.filters.merchantNumber.filter(x=>x.length>0),
            From: firstDayOfTheMonth.toJSON(),
            To: lastDayOfTheMonth.toJSON(),
            Amount:"",
            Type: "", //this.state.filters.type,
            Currency: this.state.filters.currency,
            Skip: all ? 0 : (this.state.pageRequest.Skip),
            Take: all ? 0 : (this.state.pageRequest.Take),
            AddDetail:false
        };
        return tranWebModel;
    }

    downloadZip = () =>{
        if (this.state.isCaptchaVerified) {
            this.messages.showDownloadMessage();
            FiscalSettlementService.getDownloadMonthlySettlementZip(this.getRequest(false))
                .then((response: AxiosResponse<ArrayBuffer>) => {
                })
                .catch((error) => {
                    this.setState({  errors: ["Error obteniendo datos del servidor"] });
                    console.log('error:', error);
                });
        } else {
            toast.error("Por favor, verifica el CAPTCHA antes de descargar el archivo");
        }
    };
    
    getLiquidations = () => {
        FiscalSettlementService.getMonthlySettlements(this.getRequest(false)).then((response: IMonthlySettlements) => {        
            this.setState({...this.state,
                monthlySettlements: response,
                errors: []
            });
        }).catch((error: any) => {
            this.setState({...this.state,
                errors: ["Error obteniendo datos del servidor"],
                monthlySettlements: {
                    monthlySettlements: [] as IMonthlySettlement[],
                    totalNetAmount: '',
                    totalNetAmountUS: '',
                    recordsNumber: ''
                } as IMonthlySettlements
            })
        });
    }


    searchFilter = () => {
        this.setState({
            ...this.state, mainPage: 0
        }, () => {
            this.getLiquidations();
        });
    }

    setFilters(filters: IFilters) {
        this.setState({ ...this.state, filters });
    }

    clearFilter = () => {
        const currencyOptions: Array<HTMLOptionElement> = UtilService.getCurrencyOptions();
        const currencyFilter: string = currencyOptions[0].value;
        this.multiSelectRef.current?.clearFilters();
        this.setState((prevState) => ({
            ...prevState,
            filters: {
                ...prevState.filters,
                period: (new Date().getFullYear()+"-"+(new Date().getMonth()+1)),
                fiscalDocument: [""] /* WebCache.getAllMerchantDocuments(false,true)[0]?.value+"" */,
                merchantNumber: [""],
                currency: currencyFilter,
                brands:[""]
            }
        }),()=>{
            this.searchFilter();
        });
    }

    handleClickModal = () => {
        this.setState({
            ...this.state, isModalOpen: !this.state.isModalOpen
        })
    }


    handleClickOptionModal = (event: ChangeEvent<HTMLInputElement>) => {
    let values: Map<string, boolean> = this.state.hiddenColumnsMap;
        values.set(event.target.id, !values.get(event.target.id));
        this.setState({
            ...this.state, hiddenColumnsMap: values
        });
    }

    changeColumnsTable = () => {
        let columnDefinitions: Array<ColumnDefinition> = [...this.state.columnDefinitions];
        this.state.columnDefinitions.forEach((columnDefinition, columnDefinitionIndex) => {
            columnDefinitions[columnDefinitionIndex].hidden = this.state.hiddenColumnsMap.get(columnDefinition.key);
        });
        this.setState({...this.state, columnDefinitions, isModalOpen: false});
    }



    renderProofOfWithholdings = () => {
        const { t } = this.props;
        const year: string = new Date().getFullYear().toString();
        const month: string = this.state.filters.period?.toString().padStart(2, '0');
        const formattedPeriod: string = `${month}/${year}`;

        return (
            <div className='mt-6'>
                <h1>Constancia de Retenciones</h1>
                <table className='table-downloading'>
                    <tbody>
                        <tr className="text-gray" >
                            <td className="table-row p-4">{t(`${T_PREFIX}proofOfWithholdingsColumns.period`)}</td>
                            <td className="table-row p-4">{t(`${T_PREFIX}proofOfWithholdingsColumns.description`)}</td>
                            <td className="table-row p-4">{t(`${T_PREFIX}proofOfWithholdingsColumns.download`)}</td>
                            </tr>
                                {
                                    this.state.monthlySettlements && this.state.monthlySettlements.monthlySettlements.length > 0 ?
                                        <tr className="text-strong">
                                            <td className="table-row p-4">{formattedPeriod}</td>
                                            <td className="table-row p-4">{t(`${T_PREFIX}proofOfWithholdingsColumns.descriptionText`)}</td>
                                            <td className="table-row p-4">
                                                <a {...UtilService.isMobilePlatform()?{}:{type:'button'}} className="downloadLinkWithholdings cursor-pointer" onClick={(event: any) =>  this.handleClickProofOfWithholdings(event) }>
                                                                {t(`${T_PREFIX}proofOfWithholdingsColumns.downloadLink`)}
                                                </a>         
                                            </td>
                                        </tr>
                                    :
                                <></>
                            }
                    </tbody>
                </table>
            </div>
        );
    }   

    setFiscalSelected = (selected: any) => {
        this.setState((prevState) => ({
            filters: {
            ...prevState.filters,
            fiscalDocument: selected
        }}));
    };
    
    setMerchantSelected = (selected: any) => {
        this.setState((prevState) => ({
            filters: {
            ...prevState.filters,
            merchantDocument: selected
        }}));
    };

    render() {
        const { t } = this.props;
        const currentUser = WebCache.getCurrentUser()?.countryId;
        const currentDay = (new Date()).getDate();
        let merchantDocument;
        if (currentUser !== undefined && currentUser === 2) {
            merchantDocument = `${T_PREFIX}merchantDocumentUY`
        } else {
            merchantDocument = `${T_PREFIX}merchantDocumentARG`
        }	
        
        return (
            <Page>
                <>
                    <h2>{t(`settlements`)}</h2>
                    <div className='row'>
                        <div className='col-lg-12'>
                            <ErrorsView errors={this.state.errors}/>
                        </div>
                    </div>
                    {(currentDay > 10 && currentDay < 28) ? "" :
                        <div className='row'>
                            <div className='col-lg-12'>
                                <ErrorsView errors={[i18next.t("MonthlySettlementDisclaimer")]}/>
                            </div>
                        </div>
                    }
                    <div className="row" ref={this.componentRef}>
                        <div className="col-lg-12 settlement">
                            <div className='row'>
                                <div className="col-md-9 mt-2">
                                    <NavigationTabLinksForSettlements></NavigationTabLinksForSettlements>
                                </div>
                                {UtilService.isMobilePlatform()? "":
                                <>
                                    <div className='col-md-3 fav-select pe-1´'>
                                        <a {...(UtilService.isMobilePlatform() ? {}: { type: 'button' } )}
                                        onClick={()=> console.log()}>
                                            <HeartOrangeSVG></HeartOrangeSVG>
                                        </a>
                                        <a className='mx-2 mt-2' type='button' onClick={()=> this.handleClickFavoriteModal()}>
                                            <h6>{t(T_PREFIX+'myFavorites')}</h6>
                                        </a>
                                    </div>
                                </>
                                }
                            </div>
                            <FormFilter
                                onSubmit={this.searchFilter}
                                clear={this.clearFilter}
                                hidden={UtilService.isMobilePlatform()? true : false}
                                model={[this.state.filters, this.setFilters.bind(this)]}>
                                <>
                                    <div className="row mt-2">
                                        <div className={this.divColumnSize}>
                                            <SelectField attr="period" label={t(`${T_PREFIX}period`)}
                                                options={this.getCustomMonths()}></SelectField>
                                        </div>
                                        <FilterFiscalDocumentAndCommerce
                                            changeFilter={(fiscalDocument, merchantNumber)=>{ this.setState({
                                                ...this.state,
                                                filters: {
                                                    ...this.state.filters,
                                                    merchantNumber: merchantNumber,
                                                    fiscalDocument: fiscalDocument
                                                }
                                            }); }}
                                            ref={this.multiSelectRef}
                                            includeAllFiscalDocument={true}
                                            includeWholesaler={true}
                                        />
                                        <div className={this.divColumnSize}>
                                        <MultiSelectField
                                            attr='brands'
                                            label={t(`${T_PREFIX}brand`)}
                                            options={this.state.brandOptions}
                                            selectedOptions={this.state.filters.brands}
                                            setSelectedOptions={(selected: any) => {
                                                const filtered = selected.length > 1 && selected.includes("") 
                                                    ? selected.filter((x: string) => x !== "") 
                                                    : selected;
                                                this.setFilters({ ...this.state.filters, brands: filtered });
                                            }}                              
                                            multiSelect={true}
                                        />
                                        </div>
                                        <div className={this.divColumnSize}>
                                            <SelectField attr='currency' label='currency' options={this.state.currencyOptions} ></SelectField>
                                        </div>
                                    </div>
                                </>
                            </FormFilter>
                            <nav className="nav mt-3">
                                {UtilService.isMobilePlatform()?"":
                                    <span className="vertical-align">
                                        <Button color="transparent" className="border-0 mt-0" noBlock onClick={()=> this.handleClickModal()}>
                                            <>
                                                <IconSettingSVG></IconSettingSVG>
                                                <span className='ms-2 text-dark' >{t(`common.action.tableConfig`)}</span>
                                            </>
                                        </Button>   
                                    </span>
                                }
                                <div className="navbar-text ms-auto mb-3 col-12 col-md-6 fs-5 pe-0 d-flex flex-wrap justify-content-end">
                                    {UtilService.isMobilePlatform()?"":
                                    <div className="me-3 mb-2 flex-grow-1">
                                        <ReactToPrint
                                            trigger={() => (
                                                <Button color="primary" className="border-0 mt-0 w-100" noBlock>
                                                    <>
                                                        <span className="ms-2 me-2 text-white">{t(`common.action.print`)}</span>
                                                        <IconPrintSVG></IconPrintSVG>
                                                    </>
                                                </Button>
                                            )}
                                            content={() => this.componentRef.current}
                                        />
                                    </div>}
                                    <div className="me-3 mb-2 flex-grow-1">
                                        <Button color="primary" className="border-0 mt-0 w-100" onClick={() => this.downloadGrid()} noBlock>
                                            <>
                                                <span className="ms-2 me-2">{t(`common.action.downloadCsv`)}</span>
                                                <IconDownloadWhiteSVG></IconDownloadWhiteSVG>
                                            </>
                                        </Button>
                                    </div>
                                    <div className="me-3 mb-2 flex-grow-1">
                                        <Button color="primary" className="border-0 mt-0 w-100" onClick={() => this.downloadZip()} noBlock>
                                            <>
                                                <span className="ms-2 me-2">{t(`common.action.downloadAll`)}</span>
                                                <IconDownloadWhiteSVG></IconDownloadWhiteSVG>
                                            </>
                                        </Button>
                                    </div>
                                </div>
                            </nav>
                            <div className='row'>
                                <div className="col-md-12"> 
                                    {UtilService.isMobilePlatform() ? 
                                            <div>
                                                <div className="container">
                                                    <ul className="notification">
                                                        {
                                                        this.state.monthlySettlements.monthlySettlements.slice(this.state.pages.indexOf(this.state.activePage) * pageSize, (this.state.pages.indexOf(this.state.activePage) * pageSize) + pageSize).map((monthlySettlements, Tindex) => {
                                                                return (
                                                                    <li>
                                                                        <div className="notification-icon">
                                                                            <a href="javascript:void(0);"></a>
                                                                        </div>
                                                                        <div className="notification-time-date mb-2 d-block d-md-none">
                                                                            {/* <span className="date">{t("today")}</span> */}
                                                                            {(() => {
                                                                            if (!monthlySettlements.period) {
                                                                                return '';
                                                                            }
                                                                            const period: string = monthlySettlements.period.toString();
                                                                            const year: string = period.substring(0, 4);
                                                                            const month: string = period.substring(4, 6);
                                                                            return `${month}/${year}`;
                                                                            })()}
                                                                        </div>
                                                                        <div className="settlementMobile">
                                                                            <div className="media mt-0">
                                                                                <div className="main-avatar avatar-md online" >
                                                                                    {<img src={monthlySettlements.productDesc==null?"":UtilService.getImageTag((monthlySettlements.productDesc).toUpperCase())} alt={`${monthlySettlements.productDesc}`} ></img>}
                                                                                </div>
                                                                                <div className="media-body ms-3 d-flex">
                                                                                    <div className="" >
                                                                                    <span className="amount-label">{Intl.NumberFormat('es-UY', { style: 'currency', currency: monthlySettlements.currencyDesc =="$"?"UYU":"USD" }).format(
                                                                                            monthlySettlements.netAmount)}</span>
                                                                                    <p className="mb-0 fs-13 text-dark">{t("merchantNumber")}:{(monthlySettlements.merchantNumber)}</p>                                                                                            
                                                                                </div>
                                                                                </div>
                                                                                <div style={{ width: "34px",height: "30px"}}>
                                                                                    <a onClick={() => {this.getDowloadESettlement(monthlySettlements.id, monthlySettlements.merchantNumber, monthlySettlements.productDesc, monthlySettlements.period);}}>
                                                                                        <i className="fa-sharp fa-solid fa-print text-primary" aria-hidden="true"></i>
                                                                                    </a>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </li>
                                                                    )
                                                                })}
                                                        </ul>
                                                    </div>
                                                    <div>
                                                        <Pagination
                                                            pageSize={pageSize}
                                                            pageQuantity={pageQuantity}
                                                            modifyMainPage={(value: number, newPages: Array<number>) => {
                                                                this.setState({
                                                                    mainPage: this.state.mainPage + value,
                                                                    pages: newPages
                                                                }, () => this.getLiquidations());
                                                            }}
                                                            changePage={(page: number) => this.setState({ activePage: page })}
                                                            dataL={this.state.monthlySettlements.monthlySettlements.length}
                                                            mainPage={this.state.mainPage}
                                                        ></Pagination>
                                                    </div>
                                                </div>:
                                                <CustomTable
                                                    rowObjects={this.state.monthlySettlements.monthlySettlements}
                                                    columnDefinitions={this.state.columnDefinitions}
                                                    config={{
                                                        mode: TableModeEnum.LIST,
                                                        paginator: {
                                                            mainPage: this.state.mainPage,
                                                            modifyMainPage: (value: number) => {
                                                                this.setState({
                                                                    mainPage: this.state.mainPage + value
                                                                }, () => this.getLiquidations())
                                                            },
                                                            pageRequest: this.state.pageRequest
                                                        }
                                                    }}
                                                ></CustomTable>
                                                }
                                            </div>
                                        </div>
                                    <div className='row mt-4'>
                                        <div className='col-md-6'>
                                        </div>
                                        <div className="col-md-6 d-flex justify-content-center align-items-start">
                                            <CustomReCAPTCHA useCache={true} onVerify={this.handleCaptchaVerification}></CustomReCAPTCHA>
                                        </div>
                                    </div>
                                    {this.renderProofOfWithholdings()}
                                </div>
                            </div>
                    <Modal show={this.state.isModalOpen} size='lg'>
                        <Card>
                            <>
                                <div className='pb-4'>
                                    <h2>{t(`${T_PREFIX}tableConfigTitle`)}</h2>
                                    <h6>{t(`${T_PREFIX}tableConfigDescription`)}</h6>
                                </div>
                                <div className="row">
                                    { 
                                        Array.from(this.state.hiddenColumnsMap).map((entry: [string, boolean]) => {
                                            const [key, value]: [string, boolean] = entry;
                                            return (
                                                <div className="col-md-4" key={key} >
                                                    <CheckBoxField id={key} checked={!value} label={`${T_PREFIX}columns.${key}`} onChange={(event) => this.handleClickOptionModal(event)} ></CheckBoxField>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                                <div className='d-flex flex-row-reverse gap-4'>
                                    <Button className='mt-2 ps-8 pe-8' label='accept' onClick={() => this.changeColumnsTable()} noBlock/>
                                    <Button className='mt-2 ps-8 pe-8' color='white' label='cancel' onClick={() => this.setState({...this.state, isModalOpen: false})}  noBlock />
                                </div>
                            </>
                        </Card>
                    </Modal>
                    <Modal show={this.state.isFavoriteModalOpen} size='sm'>
                        <div className='p-5 h-100'>
                            <div className='row'>
                                <div className='col-md-6 mb-2'>
                                    <h2>{t(T_PREFIX+`favorites`)}</h2>
                                </div>
                                <div className='col-md-6 d-flex justify-content-end'>
                                    <a onClick={()=> this.handleClickFavoriteModal()}>
                                        <IconCloseSVG></IconCloseSVG>
                                    </a>
                                </div>
                            </div>
                            <div className="row pb-2">
                                { 
                                    <ul className="favorite-list">
                                        { this.state.favorites.map((fav)=>{
                                            return <li className='d-flex inline-block align-items-center mb-1 favorite-button'>
                                                <a className='w-80' onClick={()=> this.applyFavorite(fav)}>
                                                    <p className='p-2 mb-0'>{fav.name}</p> 
                                                </a>
                                                <a className='ms-5 float-right w-20' onClick={()=> this.deleteFavorite(fav.name)}>
                                                    <IconTrashSVG></IconTrashSVG>
                                                </a>
                                            </li>
                                        })}
                                    </ul>
                                }
                            </div>
                            <div className="row justify-content-center">
                                <a onClick={()=> this.setState({...this.state, isMakingNewFavorite: true})} className='text-center favorite-button favorite-add-button py-2 w-60'>
                                    <span>{t('common.action.addFavorite')}</span>
                                </a>
                            </div>
                            { this.state.isMakingNewFavorite &&
                                <>
                                    <div className="row mt-5">
                                        <TextField  attr="favoriteName" model={[ this.state, this.setState.bind(this) ]} label='Nombre'></TextField>
                                    </div>
                                    <div className='row'>
                                        <Button className={`mt-2 ${ this.state.favoriteName?.length === 0 && "disabled" }`} label='accept' onClick={() => this.addNewFavorite()}/>
                                        <Button className='mt-2' label='cancel' color='white' onClick={()=> this.setState({...this.state, isMakingNewFavorite: false, favoriteName: ''})}/>
                                    </div>
                                </>
                            }
                        </div>
                    </Modal>
                </>
            </Page>
        )
    }
}
export default withMessages(withTranslation()(SettlementsByMonth));